<template>
  <div>
    <div class="com-header">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
               
              >
                <b-form-group
                  label="Start Date"
                  label-for="datepicker-1"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-1"
                    v-model="StartDate"
                    placeholder="Choose a date"
                    local="en"
                    @input="getShipmentReport()"
                    size="sm"
                    required
                    :max="EndDate"
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
              >
                <b-form-group
                  label="End Date"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-2"
                    v-model="EndDate"
                    placeholder="Choose a date"
                    local="en"
                    @input="getShipmentReport()"
                    size="sm"
                    required
                    :min="StartDate"
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <div class="custom-btn">
                <b-form-group
                  label="Depots"
                  label-for="Client"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedDepoId"
                    :options="depos"
                    value-field="id"
                    text-field="name"
                    size="sm"
                    @change="getShipmentReport()"
                  >
                    <b-form-select-option :value="0"
                      >All Depots</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                
              >
                <b-form-group
                  label="Transactions"
                  label-for="isInventory"
                  autocomplete="off"
                >
                  <b-form-select
                    id="isinventory"
                    v-model="IsInventory"
                    :options="inventoryOptions"
                    class="class-dropdown"
                    @change="getShipmentReport()"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Download to Excel"
              >
                <b-form-group
                  label="Download"
                  label-for="isInventory"
                  autocomplete="off"
                >
                  <b-btn @click="downloadExcel()" variant="light">
                    <b-icon icon="download" scale="1"></b-icon
                  ></b-btn>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <a
                  href="#filterSection"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="filterSection"
                >
                  <div class="icon">
                    <b-icon icon="filter" scale="1.7"></b-icon>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapse" id="filterSection">
        <div class="card card-body custom-filter-body">
          <div class="custom-filter-wrap">
            <div
              class="container-fluid custom-row d-flex justify-content-between"
            >
              <div class="custom-filter-column">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="datepicker-1"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-1"
                      v-model="StartDate"
                      placeholder="Choose Start Date"
                      local="en"
                      @input="getShipmentReport()"
                      required
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                 
                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-2"
                      v-model="EndDate"
                      placeholder="Choose End Date"
                      local="en"
                      @input="getShipmentReport()"
                      required
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                 
                  <b-form-group label="" label-for="Client" autocomplete="off">
                    <b-form-select
                      v-model="SelectedDepoId"
                      :options="depos"
                      value-field="id"
                      text-field="name"
                      @change="getDepos()"
                    >
                      <b-form-select-option :value="0"
                        >All Depos</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="isInventory"
                    autocomplete="off"
                  >
                    <b-form-select
                      id="isinventory"
                      v-model="IsInventory"
                      :options="inventoryOptions"
                      class="class-dropdown"
                      @change="getShipmentReport()"
                    ></b-form-select>
                  </b-form-group>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <div>
      <div class="row">
        <div class="col">
          <div class="table-responsive">
            <table
              id="printTableData"
              class="table table-striped table-borderless cutom-table table-striped table-sm"
              style="font-size: 85%;"
              ref="printTable"
            >
              <thead>
                <tr>
                  <!-- <th role="columnheader">&nbsp;</th> -->
                  <th v-for="ht in headerText" :key="ht.value">
                    {{ ht.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="shipmentData == null || shipmentData.length == 0">
                  <td colspan="8" class="center-td">No Data</td>
                </tr>

                <tr v-else v-for="rec in shipmentData" :key="rec.depoId">
                  <td role="cell" class="report-first-td">
                    {{ rec.depoName }}
                  </td>
                  <td role="cell">
                    <span v-if="rec.twentyKgSacks > 0">{{
                      rec.twentyKgSacks
                    }}</span>
                    <span v-else> - </span>
                  </td>
                  <td role="cell">
                    {{ rec.twentyKgFlourWeight }}
                  </td>
                  <td role="cell">
                    <span v-if="rec.fortyKgSacks > 0">
                      {{ rec.fortyKgSacks }}</span
                    >
                    <span v-else> - </span>
                  </td>
                  <td role="cell">{{ rec.fortyKgFlourWeight }}</td>
                  <td role="cell">
                    <span v-if="rec.eightyKgSacks > 0">
                      {{ rec.eightyKgSacks }}</span
                    >
                    <span v-else> - </span>
                  </td>
                  <td role="cell">{{ rec.eightyKgFlourWeight }}</td>
                  <!-- <td
                  role="cell"
                  v-for="item in rec.productionDetails"
                  :key="item.flourWeightTypeLinkId"
                >
                  <span v-if="item.noOfSacks > 0 || item.kGs > 0">
                    {{ item.noOfSacks }} &nbsp;Sacks {{ item.kGs }} &nbsp;KGs
                    {{ item.tons }} &nbsp;TONs
                  </span>
                  <span v-else>-</span>
                </td> -->
                  <td>
                    {{ rec.totalWeight }}
                  </td>
                </tr>
              </tbody>
              <thead v-if="shipmentData != null">
                <tr>
                  <th>Total</th>
                  <th>{{ footerText.totalTwentyKgSacks }}</th>
                  <th>{{ footerText.totalTwentyKgFlourWeight }}</th>
                  <th>{{ footerText.totalFortyKgSacks }}</th>
                  <th>{{ footerText.totalFortyKgFlourWeight }}</th>
                  <th>{{ footerText.totalEightyKgSacks }}</th>
                  <th>{{ footerText.totalEightyKgFlourWeight }}</th>
                  <th>{{ footerText.grandTotalWeight }}</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>

      <!--PAGINATION START-->
      <!-- <div class="row justify-content-between align-items-center">
        <div class="col-md-2">
          <div class="showPages">
            <select
              class="form-control"
              id="selClass"
              v-model="perPage"
              @change="getShipmentReport()"
            >
              <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-8 d-flex justify-content-center">
          <div class="overflow-auto">
            <b-pagination
              v-model="page"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
        </div>

        <div class="col-md-2">
          <input
            class="form-control search-box page-no-search"
            type="text"
            v-bind:placeholder="page"
            aria-label="search"
            v-model.number="pageNumOnSearch"
            style="height:38px"
          />

          <button
            class="search-button btn btn-primary search page-no-search-btn"
            @click="search()"
          >
            GO
          </button>
        </div>
      </div> -->
      <!--/PAGINATION END-->
      <!--SPINNER-->
      <Spinner
        v-if="isLoading"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner>
      <!--/SPINNER-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "ShipmentReportGov",
  data() {
    return {
      moduleName: "Gov Shipment Report",
      isLoading: false,

      inventoryOptions: [
        { value: true, text: "Inventory" },
        { value: false, text: "Non Inventory" },
        { value: null, text: "Transactions (All)" },
      ],
      IsInventory: null,

      StartDate: new Date(),
      EndDate: new Date(),
      productionData: null,
      productionEntries: null,
      weights: null,
      pageNumOnSearch: "",
      filteredText: "",
      rows: 0,
      page: 1,
      options: [
        { text: "Show 2", value: 2 },
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 100", value: 100 },
      ],
      perPage: 25,
      depos: [],
      SelectedDepoId: 0,
      headerText: [
        { text: "Stations", value: 1 },
        { text: "20Kg Sacks", value: 2 },
        { text: "Weight", value: 3 },
        { text: "40Kg Sacks", value: 4 },
        { text: "Weight", value: 5 },
        { text: "80Kg Sacks", value: 6 },
        { text: "Weight", value: 7 },
        { text: "Total Weight", value: 8 },
      ],
      shipmentData: null,

      footerText: null,
      cssText: `
      .printing {
        font-family: sans-serif;
        width: 500px;
        border: solid 1px #ccc;
        text-align: center;
        padding: 1em;
        margin: 2em auto;
      }

      button {
        background-color: #f0f0f0;
        border: solid 1px #bbb;
        padding: 10px;
        font-size: 15px;
        border-radius: 5px;
      }

      pre {
        color: #c7254e;
      }
    `,
    };
  },

  methods: {
    getPage(page) {
      this.page = page;
      this.getShipmentReport();
    },

    print() {
      // var divToPrint = this.$refs.printTable;
      // var myWindow = window.open("", "MsgWindow", "width=200,height=100");

      // myWindow.document.write(divToPrint.outerHTML);
      // myWindow.print();
      window.print();
    },

    getShipmentReport() {
      this.isLoading = true;
      this.shipmentData = null;
      axios
        .post("/productionreport/getallGovShipments", {
          UserId: this.$auth.user().id,
          CompanyId: this.$auth.user().companyId,
          PageSize: this.perPage,
          Page: this.page,
          FromDate: this.StartDate,
          ToDate: this.EndDate,
          IsInventory: this.IsInventory,
          DepoId: this.SelectedDepoId === 0 ? null : this.SelectedDepoId,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            // console.log(res.data)
            this.shipmentData = res.data.data.result;
            // this.rows = res.data.totalRecords;
            this.footerText = res.data.data.footerText;
          } else if (res.data.status == 0) {
            this.productionData = null;
          } else if (res.data.status == -1) {
            this.$bvModal.msgBoxOk(res.data.msg, {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              headerClass: "p-10 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          }
          this.isLoading = false;
        });
    },

    getDepos() {
      let model = {
        CompanyId: this.$auth.user().companyId,
      };
      axios.post("/depo/getdepos", model).then((res) => {
        console.log(res.data);
        this.depos = res.data.data;
      });
    },

    search() {
      this.page = this.pageNumOnSearch;
      this.getShipmentReport();
    },

    printData() {
      var divToPrint = this.$refs.printTable;
      var newwin = window.open("");
      newwin.document.write(divToPrint.outerHTML);
      newwin.print();
      newwin.close();
    },

    downloadExcel() {
      console.log("Download excel file from table");
      console.log(document.getElementById("printTableData"));
      //workbook object will be created with the table inside
      var wb = XLSX.utils.table_to_book(
        document.getElementById("printTableData"),
        {
          sheet: "Sheet JS",
        }
      );
      /*wb['!cols'][141] = { hidden: true };*/

      delete wb["141"];
      console.log(wb);
      //export it as downloadable xlsx file
      //convert into binary
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "binary",
      });

      saveAs(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        "GovShipmentReport.xlsx"
      );
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  },
  created() {
    var date = new Date();
    this.StartDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      1,
      this.StartDate.getHours()
    );
    // console.log(this.StartDate)
    // this.StartDate.setFullYear(date.getFullYear(), date.getMonth(), 1)
    this.EndDate = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0,
      this.EndDate.getHours()
    );
    // console.log(this.EndDate)
    // this.EndDate.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
    this.getDepos();
    this.getShipmentReport();

    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components: {
    Spinner,
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
.custom-row {
  overflow: visible !important;
}
.form-group {
  margin-bottom: 0.4rem;
}
.nav-tabs {
  font-size: 22px !important;
  border-bottom: none !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-bottom: 2px solid transparent !important;
}
@media print {
  .com-header {
    display: none;
  }
  .table {
    border: 1px solid #e7e1e1 !important;
  }
}
</style>
